/**
 * Client route helpers (doc 12 §A.4). The `+` in an E.164 doc id must be
 * percent-encoded in the URL (`%2B`): a literal `+` survives react-router
 * matching but is corrupted by any layer that applies query-string decoding.
 * Encoding here, decoding in the detail page, keeps that in one place.
 */
export function clientPath(businessId: string, e164: string): string {
  return `/b/${businessId}/clients/${encodeURIComponent(e164)}`;
}

/** Decode the `:e164` route param back to a raw E.164 number. */
export function parseClientParam(param: string | undefined): string {
  return param ? decodeURIComponent(param) : '';
}
